import HomePageView from "views/HomePageView/HomePageView";

export default HomePageView;